import { RefObject } from 'react';

import { PinDialogBodyRef } from 'components/PinDialog/types';

export default function showKeyboardByRef(
    ref: RefObject<PinDialogBodyRef | null>,
    keyboardWasShown?: boolean,
) {
    if (keyboardWasShown) {
        ref.current?.blur();
    }
    ref.current?.focus();
}
